import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b6c03b86")

_pushScopeId("data-v-b6c03b86")
const _hoisted_1 = { class: "cards-wrap" }
const _hoisted_2 = { class: "card-set" }
const _hoisted_3 = { class: "t-card" }
const _hoisted_4 = { class: "first-card" }
const _hoisted_5 = { class: "second-card" }
const _hoisted_6 = { class: "card-set" }
const _hoisted_7 = { class: "first-card" }
const _hoisted_8 = { class: "second-card" }
const _hoisted_9 = { class: "t-card" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["multi-card-result-root", { 'need-reverse-card-result': _ctx.gameType !== 'G002' }],
    "data-winner": _ctx.winLabel,
    "data-won": _ctx.wonLabel
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", {
          class: "third-card",
          "data-label": _ctx.blueLabel,
          "data-color": 2
        }, [
          _createVNode("div", _hoisted_3, [
            (_ctx.blueHand.length > 2)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.blue3rdCard,
                  alt: "",
                  onerror: "this.style.opacity='0'"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ])
        ], 8, ["data-label"]),
        _createVNode("div", _hoisted_4, [
          (_ctx.blueHand.length > 1)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                src: _ctx.blue2ndCard,
                alt: "",
                onerror: "this.style.opacity='0'"
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_5, [
          (_ctx.blueHand.length > 0)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                src: _ctx.blue1stCard,
                alt: "",
                onerror: "this.style.opacity='0'"
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          (_ctx.redHand.length > 0)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                src: _ctx.red1stCard,
                alt: "",
                onerror: "this.style.opacity='0'"
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_8, [
          (_ctx.redHand.length > 1)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                src: _ctx.red2ndCard,
                alt: "",
                onerror: "this.style.opacity='0'"
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", {
          class: "third-card",
          "data-label": _ctx.redLabel,
          "data-color": 1
        }, [
          _createVNode("div", _hoisted_9, [
            (_ctx.redHand.length > 2)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.red3rdCard,
                  alt: "",
                  onerror: "this.style.opacity='0'"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ])
        ], 8, ["data-label"])
      ])
    ])
  ], 10, ["data-winner", "data-won"]))
})